export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          专题汇总
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20year%20end%20summary%20aesthetic%2C%20newspaper%20headlines%20collage%2C%20warm%20crimson%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20investigative%20journalism%20style%2C%20editorial%20photography%2C%20no%20visible%20text%2C%20abstract%20news%20concept&width=640&height=360&seq=index-baoliao-01&orientation=landscape"
                alt="2024年度十大黑料盘点"
                title="2024年度十大黑料盘点"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">2024年度十大黑料盘点</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">全年最劲爆的51爆料黑料汇总，一次看够年度大瓜</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>50篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20theater%20with%20dramatic%20curtains%2C%20mysterious%20atmosphere%2C%20warm%20amber%20spotlight%2C%20cinematic%20noir%20style%2C%20investigative%20mood%2C%20editorial%20photography%2C%20no%20people&width=640&height=360&seq=index-baoliao-02&orientation=landscape"
                alt="娱乐圈潜规则深扒合集"
                title="娱乐圈潜规则深扒合集"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">娱乐圈潜规则深扒合集</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">从选角到资源分配，揭开娱乐圈不为人知的幕后交易</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>86篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20social%20media%20studio%20with%20broken%20ring%20light%2C%20dramatic%20shadows%2C%20warm%20crimson%20tones%2C%20abandoned%20equipment%2C%20investigative%20documentary%20style%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-03&orientation=landscape"
                alt="网红经济泡沫破裂实录"
                title="网红经济泡沫破裂实录"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">网红经济泡沫破裂实录</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">追踪头部网红从爆红到翻车的全过程，数据触目惊心</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>64篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20corporate%20archive%20with%20dramatic%20shadows%2C%20filing%20cabinets%20and%20documents%2C%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20investigative%20style%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-04&orientation=landscape"
                alt="上市公司财务造假档案"
                title="上市公司财务造假档案"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">上市公司财务造假档案</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">近三年被曝财务问题的上市公司完整名单与分析报告</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>42篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20split%20aesthetic%2C%20two%20wedding%20rings%20on%20dark%20surface%2C%20warm%20and%20cold%20lighting%20contrast%2C%20emotional%20mood%2C%20cinematic%20style%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-05&orientation=landscape"
                alt="明星婚变内幕全记录"
                title="明星婚变内幕全记录"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">明星婚变内幕全记录</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">从模范夫妻到分道扬镳，揭秘明星婚姻背后的真实原因</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>38篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20talent%20show%20stage%20with%20dramatic%20spotlight%2C%20empty%20judges%20table%2C%20mysterious%20shadows%2C%20warm%20crimson%20tones%2C%20cinematic%20style%2C%20investigative%20mood%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-06&orientation=landscape"
                alt="选秀节目黑幕大揭秘"
                title="选秀节目黑幕大揭秘"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">选秀节目黑幕大揭秘</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">从投票造假到导师内定，选秀产业链背后的资本游戏</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>55篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dramatic%20shadows%2C%20stainless%20steel%20surfaces%2C%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20investigative%20documentary%20style%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-07&orientation=landscape"
                alt="餐饮行业卫生黑榜"
                title="餐饮行业卫生黑榜"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">餐饮行业卫生黑榜</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">知名餐饮品牌后厨卫生问题大起底，哪些店上了黑名单</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>71篇</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20sports%20locker%20room%20with%20dramatic%20lighting%2C%20empty%20benches%2C%20mysterious%20shadows%2C%20warm%20amber%20tones%2C%20cinematic%20style%2C%20investigative%20mood%2C%20editorial%20photography&width=640&height=360&seq=index-baoliao-08&orientation=landscape"
                alt="体育圈禁药风波追踪"
                title="体育圈禁药风波追踪"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">体育圈禁药风波追踪</h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">国内外体育明星涉嫌兴奋剂的完整时间线与调查进展</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-file-text-line"></i>
                <span>33篇</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}